import { render, staticRenderFns } from "./OsdImage.vue?vue&type=template&id=4ba37153&scoped=true&lang=pug&"
import script from "./OsdImage.vue?vue&type=script&lang=ts&"
export * from "./OsdImage.vue?vue&type=script&lang=ts&"
import style0 from "./OsdImage.vue?vue&type=style&index=0&id=4ba37153&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba37153",
  null
  
)

component.options.__file = "OsdImage.vue"
export default component.exports